<template>
  <div>
    <!--<v-progress-linear v-if="loading" indeterminate></v-progress-linear>-->
    <!--<v-select v-if="$root.isMobile"
              :key="listKey"
              v-model="selectedItem"
              class="ml-3 mr-3 mt-3"
              outlined
              hide-details
              dense
              :label="$root.t('Loads.Truck')"
              :items="itemsArray"
              item-text="truck"
              item-value="id"
              @change="(val) => { onReportSubTypeChanged('/reports/trucks/' + val) }"
    />-->
    <TruckTotals :from="from"
                 :to="to"
                 :key="from+to"
                 :truckId="0"/>

    <v-layout v-if="!$root.isMobile">
      <v-flex shrink class="pl-2">
        <v-switch dense v-model="showAllSwitch" @change="fetchData" inset label="Show all"/>
      </v-flex>
      <v-flex grow class="pt-3">
        <v-text-field dense outlined class="ml-2 mr-2"
                      prepend-inner-icon="mdi-magnify"
                      placeholder="Start typing to filter truck by name"
                      v-model="search"/>
      </v-flex>
    </v-layout>
    <!--<v-list dense v-if="$root.isMobile">
      <template v-for="(item, index) in filteredItems">
        <v-list-item :key="item.truck + index" @click="onReportSubTypeChanged('/reports/trucks/' + item.id)">
          <v-list-item-content>
            <v-list-item-title><h4>{{item.truck}}</h4></v-list-item-title>
            &lt;!&ndash;<v-list-item-subtitle v-if="item.hasOwnProperty('loads')" class="text-wrap">
                <b>Loads</b>:&nbsp;{{item.loads}}&nbsp;
                <b>Miles Driven</b>:&nbsp;{{item.miles}}{{$t('milesShort')}}&nbsp;
                <b>Total Loads Rate</b>:&nbsp;${{parseFloat(item.totalLoadsRate).round(0)}}&nbsp;
                <b>Rate Per Mile</b>:&nbsp;${{item.miles ? parseFloat(item.totalLoadsRate/item.miles).round(2) : 0}}&nbsp;
                <b>Expenses</b>:&nbsp;${{parseFloat(item.totalExpenses).round(0)}}&nbsp;
                <b>Gross</b>:&nbsp;${{parseFloat(item.totalGrossIncome).round(0)}}&nbsp;
                <b>Net</b>:&nbsp;<v-chip small color="success">${{parseFloat(item.totalNetIncome).round(0)}}</v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              <v-skeleton-loader type="text"/>
            </v-list-item-subtitle>&ndash;&gt;
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="'div' + item.truck + index"/>
      </template>
    </v-list>-->

    <v-data-table
      v-if="!$root.isMobile"
      height="calc(100vh - 300px)"
      fixed-header
      dense
      :items-per-page="-1"
      :headers="headers"
      :hide-default-footer="true"
      :items="filteredItems"
      @click:row="onReportSubTypeChanged('/reports/trucks/' + $event.id)"
    >
      <template v-slot:item.miles="{ item }">{{item.totalTruckMilesByOdometer}}{{$t('milesShort')}}</template>
      <template v-slot:item.totalLoadsRate="{ item }">{{$root.moneyValue(item.totalLoadsRate, 0)}}</template>
      <template v-slot:item.totalLoadsRatePerMile="{ item }">{{$root.moneyValue(item.miles ? parseFloat(item.totalLoadsRate/item.miles) : 0, 2)}}</template>
      <template v-slot:item.totalGrossIncome="{ item }">{{$root.moneyValue(item.totalGrossIncome, 0)}}</template>
      <template v-slot:item.totalExpenses="{ item }">{{$root.moneyValue(item.totalExpenses, 0)}}</template>
      <template v-slot:item.totalNetIncome="{ item }"><v-chip small color="success">{{$root.moneyValue(item.totalNetIncome, 0)}}</v-chip></template>
    </v-data-table>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import TruckTotals from './TruckTotals';
export default {
  name: 'TrucksTotalsList',
  props: ['to', 'from'],
  mixins: [ reportsMixin ],
  components: {
    TruckTotals
  },
  data: function () {
    return {
      loading: false,
      items: {},
      itemsArray: [],
      totalsCounts: {},
      search: '',
      showAllSwitch: false,
      listKey: 'trucksList',
      selectedItem: 0,
      headers: [
        { text: 'Truck Name', value: 'truck' },
        { text: 'Loads', value: 'loadsCount' },
        { text: 'Miles Driven', value: 'miles' },
        { text: 'Loads Rate', value: 'totalLoadsRate' },
        { text: 'Rate Per Mile', value: 'totalLoadsRatePerMile' },
        { text: 'Gross', value: 'totalGrossIncome' },
        { text: 'Expenses', value: 'totalExpenses' },
        { text: 'Net', value: 'totalNetIncome' },
      ]
    };
  },
  mounted () {
    this.fetchData();
  },
  computed: {
    filteredItems () {
      if (this.search.length === 0) {
        return Object.values(this.items);
      }
      return Object.values(this.items).filter((item) => {
        return item.truck.toLowerCase().match(this.search);
      });
    }
  },
  methods: {
    onReportSubTypeChanged (path) {
      this.$root.setLocalStorageItem('reportTypePath', path);
      this.$root.route(path);
    },
    async fetchData () {
      let i = 0;
      let response = {};
      let trucks = [];
      if (!this.from || !this.to) return;
      this.$set(this, 'loading', true);
      // Get total miles
      this.items = [];
      response = await this.$root.getTrucksList();
      if (response.status === 'ok') {
        this.itemsArray = [ { id: 0, truck: 'All' } ];
        trucks = response.result;
        for (i = 0; i < trucks.length; i++) {
          if (!this.showAllSwitch && parseInt(trucks[i].status) < 0) continue;
          this.items[trucks[i].id] = {
            id: trucks[i].id,
            truck: trucks[i].name
          };
          this.itemsArray.push({
            id: trucks[i].id,
            truck: trucks[i].name
          });
        }
      }
      // Calc totals only for a big screen
      if (!this.$root.isMobile) {
        for (i = 0; i < trucks.length; i++) {
          if (!this.showAllSwitch && parseInt(trucks[i].status) < 0) continue;
          response = await this.getTrucksReportTotalData(this.from, this.to, trucks[i].id);
          if (response.status === 'ok') {
            this.$set(this.items, trucks[i].id, response.results);
          }
        }
      }
      this.$set(this, 'listKey', 'trucksList' + new Date().getTime());
      this.$set(this, 'loading', false);
    }
  }
};
</script>
